export const HOME = "/";
export const CONTACT = "/contacto";
export const ABOUT = "/acerca";
export const STATISTICS_DETAIL = "/datos/acerca/:id";
// Una ruta propia evita confundir recursos y nodos que comparten identificador.
export const RESOURCE_DETAIL = "/datos/recursos/:resourceId";
export const resourceDetailPath = (slug: string) =>
  RESOURCE_DETAIL.replace(":resourceId", encodeURIComponent(slug));
export const STATISTICS = "/datos";
export const STATISTICS_ONE = "/datos/:id";
export const DOCS = "/documentacion";
export const DOCS_ID = "/documentacion/:id";
export const DIRECTORY = "/contacto/directorio";
export const ENVIRONMENTAL = "/contacto/ambiental";
export const QUESTIONS = "/faq";
export const SIS = "/sis";
export const SIS_ONE = "/sis/:id";
export const NEWS = "/noticias";
export const NEWS_ONE = "/noticias/:id";
